import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

// Import styles
import classes from "./ConfirmModal.module.scss";
import { IConfirmModalProps } from "./module/constants";

// Import messages
import messages from "./module/messages";

const ConfirmModal = (props: IConfirmModalProps) => {
  const { show, isDeletingBr, onCancel, onConfirm, customText, extraMessage } =
    props;
  return (
    <>
      <Modal
        show={show}
        size="sm"
        onHide={onCancel}
        centered
        contentClassName={classes.content}
      >
        <Modal.Header className={classes.header}>
          <Modal.Title style={{ fontSize: "1rem" }}>
            <FormattedMessage {...messages.title} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "0.75rem", textAlign: "center" }}>
          {isDeletingBr && (
            <div style={{ marginBottom: "0.5rem", fontFamily: "mb" }}>
              <FormattedMessage {...messages.deleteBrContent} />
            </div>
          )}
          {extraMessage ? (
            <div style={{ marginBottom: "0.5rem", fontFamily: "mb" }}>
              {extraMessage}
            </div>
          ) : null}
          {/* <FormattedMessage {...messages.content} /> */}
          {!customText && <FormattedMessage {...messages.content} />}
          {customText && <div>{customText}</div>}
        </Modal.Body>
        <Modal.Footer className={classes.footer}>
          <button
            className={`${classes.btn} ${classes["btn-cancel"]}`}
            onClick={onCancel}
          >
            <FormattedMessage {...messages.cancel} />
          </button>
          <button
            className={`${classes.btn} ${classes["btn-confirm"]}`}
            onClick={onConfirm}
          >
            <FormattedMessage {...messages.confirm} />
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfirmModal;
